import React from "react"
import {ShoppingBagBadge} from "./components"

export type DefaultShoppingBagBadgeProps = {
    children: React.ReactNode
    items: number | string
}

const DefaultShoppingBagBadge = ({children, items}: DefaultShoppingBagBadgeProps) => (
    <ShoppingBagBadge badgeContent={items} invisible={items === "" || items === 0}>
        {children}
    </ShoppingBagBadge>
)

export default DefaultShoppingBagBadge
